import { t as PACKAGE_VERSION } from "./version-BVfKiZvw.mjs";
//#region src/client.ts
const ssoClient = (options) => {
	return {
		id: "sso-client",
		version: PACKAGE_VERSION,
		$InferServerPlugin: {},
		pathMethods: {
			"/sso/providers": "GET",
			"/sso/get-provider": "GET"
		}
	};
};
//#endregion
export { ssoClient };
